import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import ReconciliationHistory from "./ReconciliationHistory";
import useReconciliationViewController from "../../viewControllers/ReconciliationViewController";
import DiscrepanciesStatus from "./DiscrepanciesStatus";
import SyncIcon from '@mui/icons-material/Sync';
import Loader from "../../components/Loader";
import i18n from "../../constants/Strings";

const Reconciliation = () => {

  const {
    reconciliationStatus,
    message,
    startDate,
    endDate,
    setEndDate,
    reconciliationFile,
    setUploadFile,
    enableUpload,
    onContinue,
    onReload,
    onApproveOrReject,
    downloadReconciliationfile,
    loading,
    reconciliationHistory,
    setShowConfirmationModal,
    showConfirmationModal,
    setApprovalStatus,
    uploadFile,
    fileName,
    downloadSampleCSV,
    setFileName,
  } = useReconciliationViewController();

  const text = {
    pageHeading: i18n.t('reconciliation.pageHeading'),
    statusTabTitle: i18n.t('reconciliation.statusTabTitle'),
    historyTabTitle: i18n.t('reconciliation.historyTabTitle'),
  }

  return (
    <>
      {loading ? <Loader /> : (
      <div className="container-fluid">
        <div className="card-header py-3">
         <div className="back-btn text-left cursor-pointer"> <SyncIcon onClick={onReload} /></div>
          <h6 className="m-0 font-weight-bold txt-primary">
            {text.pageHeading}
          </h6>
        </div>
        <Tabs
          defaultActiveKey="status"
          className="mb-3"
          fill
        >
          <Tab eventKey="status" title={text.statusTabTitle}>
            <DiscrepanciesStatus
              reconciliationStatus={reconciliationStatus}
              message={message}
              startDate={startDate}
              endDate={endDate}
              setEndDate={setEndDate}
              reconciliationFile={reconciliationFile}
              setUploadFile={setUploadFile}
              enableUpload={enableUpload}
              onContinue={onContinue}
              onApproveOrReject={onApproveOrReject}
              downloadReconciliationfile={downloadReconciliationfile}
              setShowConfirmationModal={setShowConfirmationModal}
              showConfirmationModal={showConfirmationModal}
              setApprovalStatus={setApprovalStatus}
              uploadFile={uploadFile}
              fileName={fileName}
              setFileName={setFileName}
              downloadSampleCSV={downloadSampleCSV}
             />
          </Tab>

          <Tab eventKey="history" title={text.historyTabTitle}>
            <ReconciliationHistory reconciliationHistory={reconciliationHistory} downloadReconciliationfile={downloadReconciliationfile}/>
          </Tab>
        </Tabs>
      </div>
      )}
    </>
  );
};

export default Reconciliation;
